import { render, staticRenderFns } from "./VideoNotAvailable.vue?vue&type=template&id=9ebc4506&"
import script from "./VideoNotAvailable.vue?vue&type=script&lang=js&"
export * from "./VideoNotAvailable.vue?vue&type=script&lang=js&"
import style0 from "./VideoNotAvailable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCardText,VCol,VIcon,VImg,VRow})
